import { HEADER_CHAT_BELL_UNREAD_MAX } from './HeaderChatBell.constants';

export const formatUnreadBadge = count => {
  if (!count) {
    return '';
  }

  if (count > HEADER_CHAT_BELL_UNREAD_MAX) {
    return `${HEADER_CHAT_BELL_UNREAD_MAX}+`;
  }

  return String(count);
};

export const getTooltipLabel = count => {
  if (!count) {
    return 'Messages (no unread)';
  }

  return `Messages (${count} unread)`;
};
